import CloseIcon from "@mui/icons-material/Close";
import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormHelperText from "@mui/material/FormHelperText";
import IconButton from "@mui/material/IconButton";
import Switch from "@mui/material/Switch";
import React, { useEffect, useState } from "react";
import { BootstrapDialog } from "../../components/BootstrapDialogTitle";
import GenreService from "./GenreServie";

export default function GenreCreateDialog({ open, setOpen, callback }) {
    const [formData, setFormData] = useState({
        name: "",
        displayOrder: 1,
        description: "",
        active: false,
        orderLevel: "",
        parentId: "",
    });

    const [genres, setGenres] = useState([]);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (open) {
            GenreService.requestGenre(undefined).then((r) => {
                const rootElements = r.filter((e) => e.parentGenre == undefined);
                setGenres(rootElements);
            });
        }
    }, [open]);

    const handleClose = () => {
        setOpen(false);
        setFormData({
            name: "",
            displayOrder: 1,
            description: "",
            active: false,
            orderLevel: "",
            parentId: "",
        });
    };

    const handleFormChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const validate = () => {
        const { name, displayOrder, description } = formData;
        const newErrors = {};

        if (!name.trim()) newErrors.name = "Genre Name is required.";
        if (displayOrder <= 0) newErrors.displayOrder = "Display Order must be greater than 0.";
        if (!description.trim()) newErrors.description = "Description is required.";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleCreate = () => {
        if (validate()) {
            const { name, displayOrder, description, active, parentId } = formData;
            GenreService.createGenre(name, displayOrder, description?.trim(), active, parentId).then(() => {
                handleClose();
                callback();
            });
        }
    };

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                sx={{
                    "& .MuiDialog-paper": {
                        width: 400,
                        margin: 0,
                    },
                }}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    New Genre
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12 }}>
                            <TextField
                                autoFocus
                                margin="dense"
                                label="Genre Name"
                                fullWidth
                                variant="outlined"
                                name="name"
                                value={formData.name}
                                onChange={handleFormChange}
                                error={Boolean(errors.name)}
                                helperText={errors.name}
                            />
                            <TextField
                                margin="dense"
                                label="Display Order"
                                fullWidth
                                type="number"
                                variant="outlined"
                                name="displayOrder"
                                value={formData.displayOrder}
                                onChange={handleFormChange}
                                error={Boolean(errors.displayOrder)}
                                helperText={errors.displayOrder}
                            />
                            <TextField
                                margin="dense"
                                label="Description"
                                fullWidth
                                variant="outlined"
                                multiline
                                rows={4}
                                name="description"
                                value={formData.description}
                                onChange={handleFormChange}
                                error={Boolean(errors.description)}
                                helperText={errors.description}
                            />
                            <FormControl fullWidth margin="dense">
                                <InputLabel id="parent-genre-label">Parent Genre</InputLabel>
                                <Select
                                    labelId="parent-genre-label"
                                    id="parentId"
                                    name="parentId"
                                    value={formData.parentId}
                                    onChange={handleFormChange}
                                    label="Parent Genre"
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {genres.map((genre) => (
                                        <MenuItem key={genre.id} value={genre.id}>
                                            {genre.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText>First level of genre can be selected. The system supports 2 levels of depth now.</FormHelperText>
                            </FormControl>
                            <FormGroup>
                                <FormControlLabel control={<Switch name="active" checked={formData.active} onChange={handleFormChange} />} label="Active" />
                            </FormGroup>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="primary" onClick={handleCreate}>
                        Create
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}
